module.exports = __webpack_public_path__ + "static/img/code1.60e65b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/code1.jpg
// module id = F5UT
// module chunks = 44